import { Types } from '@store/types';

const initialState = [];

const FactoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_FACTORY_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default FactoryReducer;
